import { render, staticRenderFns } from "./ImportErrorList.vue?vue&type=template&id=04f8b283&scoped=true"
import script from "./ImportErrorList.vue?vue&type=script&lang=js"
export * from "./ImportErrorList.vue?vue&type=script&lang=js"
import style0 from "./ImportErrorList.vue?vue&type=style&index=0&id=04f8b283&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f8b283",
  null
  
)

export default component.exports